import React, { useState, useEffect } from 'react';
import '../css/adminSidebar.css';

function AdminSidebar({ activeSection, setActiveSection }) {
  const [currentUser, setCurrentUser] = useState(null);

  const allSections = [
    { 
      id: 'dashboard', 
      name: 'Dashboard', 
      icon: 'fa-tachometer-alt',
      description: 'System overview',
      roles: ['super-admin', 'admin']
    },
    { 
      id: 'bookings', 
      name: 'Bookings', 
      icon: 'fa-calendar-check',
      description: 'Manage bookings',
      roles: ['super-admin', 'admin', 'booker']
    },
    { 
      id: 'services', 
      name: 'Services', 
      icon: 'fa-concierge-bell',
      description: 'Manage services',
      roles: ['super-admin', 'admin']
    },
    { 
      id: 'organize', 
      name: 'Organize', 
      icon: 'fa-sort',
      description: 'Organize service order',
      roles: ['super-admin', 'admin']
    },
    { 
      id: 'promotions', 
      name: 'Promotions', 
      icon: 'fa-tags',
      description: 'Manage promotions',
      roles: ['super-admin', 'admin']
    },
    { 
      id: 'payments', 
      name: 'Payments', 
      icon: 'fa-cash-register',
      description: 'Payment processing',
      roles: ['super-admin', 'admin', 'cashier']
    },
    { 
      id: 'transactions', 
      name: 'Transactions', 
      icon: 'fa-receipt',
      description: 'Transaction history',
      roles: ['super-admin', 'admin', 'cashier']
    },
    { 
      id: 'news-commitments', 
      name: 'News and Commitments', 
      icon: 'fa-newspaper',
      description: 'Manage news and commitments',
      roles: ['super-admin', 'admin']
    }
  ];

  useEffect(() => {
    const auth = localStorage.getItem('adminAuth');
    if (auth) {
      try {
        const parsedAuth = JSON.parse(auth);
        setCurrentUser(parsedAuth);
      } catch (error) {
        console.error('Error parsing auth data:', error);
      }
    }
  }, []);

  // Role-based access control for sections
  const getAccessibleSections = () => {
    if (!currentUser) return [];

    return allSections.filter(section => 
      section.roles.includes(currentUser.role)
    );
  };

  const sections = getAccessibleSections();

  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">
        <h2>Admin Dashboard</h2>
      </div>
      
      <div className="sidebar-content">
        <h3>Navigation</h3>
        <ul className="section-list">
          {sections.map(section => (
            <li key={section.id}>
              <button
                className={`section-button ${activeSection === section.id ? 'active' : ''}`}
                onClick={() => setActiveSection(section.id)}
              >
                <i className={`fas ${section.icon}`}></i>
                <div className="section-info">
                  <span className="section-name">{section.name}</span>
                  <span className="section-description">{section.description}</span>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AdminSidebar;